import {Modal} from 'shells/modal/modal';
import type {Widget} from 'shells/widgets/types';

import type {EntityType} from 'nutshell-graphql-types';

import type {Option} from '../../core/select/graphql-select-inline';

import {CreateOrEditWidgetForm} from './create-or-edit-widget-form';
import {mapSelectOptionToWidget} from './helpers';

type Props = {
    onClose: () => void;
    widget: Widget | null | undefined;
    onSave: (widget: Widget) => void;
    entityType: EntityType;
};

export const CreateOrEditWidgetModal = (props: Props) => {
    const mapAndSave = (name: string, customFields: Array<Option>) => {
        const widget: Widget = mapSelectOptionToWidget(
            props.widget ? props.widget.id : undefined,
            name,
            customFields
        );

        props.onSave(widget);
    };

    return (
        <Modal isOpen={true} onClose={props.onClose} noPadding={true}>
            <CreateOrEditWidgetForm
                widget={props.widget}
                entityType={props.entityType}
                onSave={mapAndSave}
            />
        </Modal>
    );
};
